type StripsDataEffectProps = { keyRecoil: string };

/**
 * Placeholder effect component for the strips management tab's store wiring, left behind by the Recoil layer. It logs the tab key it was handed and renders nothing.
 *
 * @param keyRecoil - Store key identifying the strips tab.
 * @returns Nothing rendered.
 */
const StripsDataEffect = ({ keyRecoil }: StripsDataEffectProps): null =>
  // use recoil getter

  // use recoil setter

  // use recoil value

  // use recoil getter not keyRecoil

  // use recoil setter not keyRecoil

  // use recoil state

  null;
export default StripsDataEffect;
